import { WidgetsTypeEnum } from "src/app/enums/widgets/widgets-type.enum";
import { WidgetsContainerAbstract } from "src/app/abstract/widgets/widgets-container.abstract";
import { WidgetsAbstract } from "src/app/abstract/widgets/widgets.abstract";

export class WidgetsRowModel extends WidgetsContainerAbstract {
    readonly widgetType: WidgetsTypeEnum = WidgetsTypeEnum.ROW;
    readonly badge: string = 'R';
    readonly icon: string = 'table_rows';    
    readonly placeholderClassName: string = 'row-placeholder';
    name: string = 'Row';
    template = '';

    children: WidgetsAbstract[] = [];
    
    toJSON() : any {
        return { 
            badge: this.badge, 
            widgetType: this.widgetType,
            id: this.id,            
            parentId: this.parentId,
            name: this.name,            
            template: this.template ? this.template : undefined,     
            children: this.children ? this.children : undefined
         };
    }
    
    /**
     * Clone from a provided origin.
     * @note Id/uuid is not cloned 
     * @param origin
     * @returns the cloned node
     */
     cloneFrom(origin: WidgetsRowModel) : WidgetsRowModel {
        this.name = origin.name;        
        if (origin.template) {
            this.template = origin.template;
        }        
        if (origin.parentId) {
            this.parentId = origin.parentId;
        }
        this.isSelected = origin.isSelected;
        return this;
    }
}